const getAsArray = (input: string | string[]): string[] => (Array.isArray(input) ? input : [input]);

export default getAsArray;
